export default {
  actions: {
    submit: 'Enviar',
    add_guest: 'Añadir huésped'
  },
  title: {
    main: 'Crear reserva',
    unauthorized: 'Sesión caducada'
  },
  message: {
    complete_main: 'Proceso completado. Puedes cerrar esta ventana.'
  },
  fields: {
    facility: 'Instalación',
    checkout: 'Checkout',
    name: 'Nombre',
    last_name: 'Apellido',
    guests: 'Huéspedes',
    identifier: 'Identificador'
  },
  error: {
    unauthorized: 'Parece que tu inicio de sesión ha caducado. Vuelve al panel e inicia sesión de nuevo.'
  }
}
